import { RefreshCw } from 'lucide-react';
import unexpectedErrorMascot from '../../assets/unexpected-error-mascot.svg';

export const ErrorBoundaryUI = ({
  embedded = false,
  onRetry,
  retrying = false,
}: {
  embedded?: boolean;
  onRetry?: () => void;
  retrying?: boolean;
}) => {
  const Heading = embedded ? 'h2' : 'h1';
  const handleReload = () => {
    window.location.assign('/');
  };

  return (
    <div
      className={`${
        embedded ? 'tw-min-h-64 tw-py-6' : 'tw-min-h-screen'
      } tw-w-full tw-flex tw-flex-col tw-items-center tw-overflow-hidden`}
      role={embedded ? 'alert' : undefined}
      style={{
        backgroundColor: '#F9F8F5',
        backgroundImage:
          'linear-gradient(to right, rgba(0,0,0,0.06) 1px, transparent 1px), linear-gradient(to bottom, rgba(0,0,0,0.06) 1px, transparent 1px)',
        backgroundSize: '32px 32px',
      }}
    >
      <div className="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-px-4 tw-text-center">
        <Heading className="tw-text-3xl tw-font-bold tw-text-neutral-950 tw-leading-snug tw-m-0">
          Oops!
          <br />
          An unexpected error occurred
        </Heading>
        <p role={retrying ? 'status' : undefined} className="tw-text-base tw-text-neutral-600 tw-m-0">
          {retrying ? 'Trying again...' : onRetry ? 'Please try again' : 'Please reload the page'}
        </p>
        <button
          type="button"
          onClick={() => {
            if (!retrying) (onRetry ?? handleReload)();
          }}
          aria-disabled={retrying || undefined}
          className={`tw-flex tw-items-center tw-gap-2 tw-bg-blue-500 tw-text-white tw-font-semibold tw-text-sm tw-px-6 tw-py-3 tw-rounded-full tw-mt-2 tw-border-none tw-transition-colors ${
            retrying ? 'tw-opacity-60 tw-cursor-wait' : 'tw-cursor-pointer hover:tw-bg-blue-700'
          }`}
        >
          {onRetry ? 'Try again' : 'Reload page'}
          <RefreshCw className="tw-h-4 tw-w-4" />
        </button>
      </div>

      {!embedded && (
        <div className="tw-w-full tw-flex tw-justify-center">
          <img src={unexpectedErrorMascot} alt="" aria-hidden="true" className="tw-w-full tw-max-w-2xl" />
        </div>
      )}
    </div>
  );
};
